import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import {PropType, ref, Ref, watch} from "vue";
import {AspectRatio} from "@/lib/components/flexible/enum/AspectRatio";
import AspectRatioedElement from "@/lib/components/flexible/AspectRatioedElement.vue";
import ScrollableElement from "@/lib/components/flexible/ScrollableElement.vue";
import {PageContentLayoutPositioning} from "@/lib/components/layout/page/enum/PageContentLayoutPositioning";
import {vElementSize} from '@vueuse/components';
import {PageContentLayoutSpaceTaken} from "@/lib/components/layout/page/enum/PageContentLayoutSpaceTaken";
import PageContentLayoutSpaceTakenPaddings from "@/lib/components/layout/page/enum/PageContentLayoutSpaceTakenPaddings";

// ------------------------------
//   Props
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'PageContent',
  props: {
  aspectRatio: {
    type: String as PropType<AspectRatio>,
    default: "initial"
  },
  pageContentLayoutPositioning: {
    type: String as PropType<PageContentLayoutPositioning>,
    default: PageContentLayoutPositioning.CENTER
  },
  pageContentLayoutSpaceTaken: {
    type: String as PropType<PageContentLayoutSpaceTaken>,
    default: PageContentLayoutSpaceTaken.MODERATELY
  },
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "7d5dce05": (flexDirection.value),
  "4a93e59c": (alignItems.value),
  "88661e58": (pagePaddingTop.value),
  "0795e44a": (pagePaddingRight.value),
  "6f79c64c": (pagePaddingBottom.value),
  "84653f30": (pagePaddingLeft.value)
}))




// ------------------------------
//   Page alignment
// ------------------------------

const alignments = {
  [PageContentLayoutPositioning.FLEX_START]: "flex-start",
  [PageContentLayoutPositioning.CENTER]: "center",
  [PageContentLayoutPositioning.FLEX_END]: "flex-end",
}

const pageHolder: Ref<typeof ScrollableElement|undefined> = ref<typeof ScrollableElement>();

const alignItems = ref(alignments[props.pageContentLayoutPositioning]),
    flexDirection = ref("column");

const adjustDimensions = ({width, height}: {width: number, height: number}) =>
{
  if (
      pageHolder.value
      && props.aspectRatio && props.aspectRatio in AspectRatio
      && alignItems.value === alignments[PageContentLayoutPositioning.CENTER]
  ) {
    const ratioWidth = +props.aspectRatio.split("/")[0],
        ratioHeight = +props.aspectRatio.split("/")[1];

    if (
        (width / height)
        > (ratioWidth / ratioHeight)
    ) {
      flexDirection.value = "column";
    } else {
      flexDirection.value = "row";
    }
  }
};

// ------------------------------
//   Page padding
// ------------------------------

const getPagePadding = (direction: "paddingLeft"|"paddingRight"|"paddingTop"|"paddingBottom"): string =>
{
  return PageContentLayoutSpaceTakenPaddings[props.pageContentLayoutSpaceTaken][props.pageContentLayoutPositioning][direction] + "px";
}

const pagePaddingLeft = ref(),
    pagePaddingRight = ref(),
    pagePaddingTop = ref(),
    pagePaddingBottom = ref();

const recalculatePagePadding = () => {
  pagePaddingLeft.value = getPagePadding("paddingLeft");
  pagePaddingRight.value = getPagePadding("paddingRight");
  pagePaddingTop.value = getPagePadding("paddingTop");
  pagePaddingBottom.value = getPagePadding("paddingBottom");
};

recalculatePagePadding();

watch(() => props.pageContentLayoutPositioning, () => {
  recalculatePagePadding();
});

watch(() => props.pageContentLayoutSpaceTaken, () => {
  recalculatePagePadding();
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(ScrollableElement, {
    class: "page",
    ref_key: "pageHolder",
    ref: pageHolder
  }, {
    default: _withCtx(() => [
      _createVNode(AspectRatioedElement, {
        ratio: __props.aspectRatio,
        "custom-class": "page-content"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["ratio"])
    ]),
    _: 3
  })), [
    [_unref(vElementSize), adjustDimensions]
  ])
}
}

})